const AccessDenied = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #f5f7ff 0%, #ede9fe 50%, #f0f4ff 100%)",
      }}
    >
      <div
        style={{
          textAlign: "center",
          padding: "60px 48px",
          background: "#ffffff",
          borderRadius: "24px",
          boxShadow: "0 20px 60px rgba(91, 72, 232, 0.12), 0 4px 16px rgba(0,0,0,0.06)",
          maxWidth: "460px",
          width: "90%",
        }}
      >
        {/* Lock icon with glow ring */}
        <div
          style={{
            position: "relative",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100px",
            height: "100px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, #5b48e8 0%, #7c3aed 100%)",
            boxShadow: "0 0 0 12px rgba(91, 72, 232, 0.12), 0 8px 32px rgba(91, 72, 232, 0.35)",
            marginBottom: "32px",
          }}
        >
          <i
            className="fas fa-lock"
            style={{ fontSize: "40px", color: "#ffffff" }}
          />
        </div>

        {/* Heading */}
        <h2
          style={{
            fontSize: "22px",
            fontWeight: 700,
            color: "#1e1b4b",
            marginBottom: "12px",
            letterSpacing: "-0.3px",
          }}
        >
          Access Denied
        </h2>

        {/* Message */}
        <p
          style={{
            fontSize: "15px",
            color: "#6b7280",
            lineHeight: 1.6,
            marginBottom: "36px",
          }}
        >
          You do not have permission to access this page.
          <br />
          Please contact your administrator if you think this is a mistake.
        </p>

        {/* Go back button */}
        <button
          onClick={() => window.history.back()}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            padding: "11px 28px",
            background: "linear-gradient(135deg, #5b48e8 0%, #7c3aed 100%)",
            color: "#ffffff",
            border: "none",
            borderRadius: "10px",
            fontSize: "14px",
            fontWeight: 600,
            cursor: "pointer",
            boxShadow: "0 4px 14px rgba(91, 72, 232, 0.35)",
            transition: "opacity 0.2s",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.88")}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
        >
          <i className="fas fa-arrow-left" style={{ fontSize: "13px" }} />
          Go Back
        </button>
      </div>
    </div>
  );
};

export default AccessDenied;
